import {getDimensions} from './../../../services/stockJournal/dimension';

export default {
    namespaced: true,
    state: {
        dimensions: []
    },
    getters: {
        dimensions: state => state.dimensions
    },
    mutations: {
        setDimensions: (state, payload) => state.dimensions = payload
    },
    actions: {
        fetchDimensions: (context) => {
            return new Promise((resolve, reject) => {
                getDimensions()
                    .then(response => {
                        context.commit("setDimensions", response.data);
                        resolve(response);
                    })
                    .catch(error => reject(error));
            });
        }
    }
}